import React from "react";
import Competences from "../components/Competences";
import FormationsSeminaires from "../components/FormationsSeminaires";

export default function ServicesPage() {
  return (
    <div>
      <Competences />
      <FormationsSeminaires />
    </div>
  );
}
